<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Belge Türü</label>
            <v-select-list :options="types" label="Name" v-on:input="setEndDate" v-model="type" placeholder="Belge Türü"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-date-picker placeholder="Başlangıç Tarihi" v-on:input="setEndDate" v-model="value.StartDate"></v-date-picker>
        </div>
        <div class="col-12 mb-1" v-if="type != null && $safe(type,'IsHasValidityYear') == true" >
            <label class="form-label">Bitiş Tarihi</label>
            <v-date-picker :disabled="$safe(type,'IsHasValidityYear') == true" placeholder="Bitiş Tarihi" v-model="value.EndDate"></v-date-picker>
        </div>
        <div class="col-12" v-if="$safe(type,'FileRequired')">
            <v-file-uploader :accept="['xlsx','png','jpg','doc','docx','xls','pdf','jpeg','txt']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import SRCApi from '@/api/src-o'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import moment from 'moment'

export default{
    components:{
        VFileUploader
    },
    props:{
        value:Object
    },
    data(){
        return {
            types:[]
        }
    },
    mounted(){
        this.getTypes()
    },
    methods:{
        getTypes(){
            SRCApi.List().then(res => {
                this.types = res.data.Data || []
            })
        },
        setEndDate(){
            if(this.type != null && this.type?.IsHasValidityYear == true && this.value.StartDate && this.type?.ValidityYear){
                this.value.EndDate = moment(this.value.StartDate,'YYYY-MM-DD').add('years',this.type.ValidityYear || 0).format('YYYY-MM-DD')
            }else{
                this.value.EndDate = null
            }
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.SRCFileTypeId)
            },
            set:function(value){
                this.value.SRCFileTypeId = value?.Id || null
                this.value.FileRequired = value?.FileRequired || null
                this.value.IsHasValidityYear = value?.IsHasValidityYear || null
            }
        }
    }
}
</script>